import { render, staticRenderFns } from "./ReceiveAddress.vue?vue&type=template&id=39d6d2db&scoped=true&"
import script from "./ReceiveAddress.vue?vue&type=script&lang=js&"
export * from "./ReceiveAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6d2db",
  null
  
)

export default component.exports